import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>404</h1>
      <p className={styles.description}>{t('pages.notFound.description')}</p>
      <Link to="/" className={styles.link}>{t('pages.notFound.backHome')}</Link>
    </div>
  );
}
